// extracted by mini-css-extract-plugin
export default {"treeSelect":"index_treeSelect__Geud8"};